import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pick } from 'ramda';
import { useI18nSelector } from 'js/store/hooks';

import * as helpers from '../helpers';
import * as actions from '../store/actions';

export const useTranslationsService = () => {
    const { translations, defaultTranslations } = useI18nSelector(pick(['translations', 'defaultTranslations']));
    const i18nDispatch = useDispatch();
    const showTranslationKeys = new URLSearchParams(location.search).has('showTranslationKeys');

    useEffect(() => {
        if (showTranslationKeys) {
            i18nDispatch(actions.showTranslationKeysAction(true));
        }
    }, [showTranslationKeys, i18nDispatch]);

    useEffect(() => {
        if (showTranslationKeys) {
            helpers.validateTranslations({ translations, defaultTranslations });
        }
    }, [translations, defaultTranslations, showTranslationKeys]);
};
